import {Component, OnDestroy, OnInit} from "@angular/core";
import {CirfService} from "../cirf.service";
import {Cirf} from "../cirf";
import {FormControl, FormGroup} from "@angular/forms";
import {CirfConfigService} from "../config/cirf-config-service";

@Component({
    selector: 'dp-existing-mortgage-note',
    templateUrl: './existing-mortgage-note.component.html'
})
export class ExistingMortgageNoteComponent implements OnInit, OnDestroy {
    showMortgageNotesStep: boolean;
    mortgageNotesFieldKey: string;

    constructor(public cirfService : CirfService,
                private cirfConfigService: CirfConfigService) { }

    ngOnInit() {
        this.mortgageNotesFieldKey = 'existingMortgage.mortgageNotes';
        this.showMortgageNotesStep = !this.cirfConfigService.isFieldHidden(this.mortgageNotesFieldKey);
        this.onChanges();
    }


    get cirfFormGroup() : FormGroup{
        return (this.cirfService.cirfFormGroup as FormGroup);
    }

    ngOnDestroy() : void {
        this.cirfService.updateCirf('INPROGRESS');
    }

    onChanges(): void {
        this.cirfService.saveChangesOnCirfFormChanges();
    }
}
